import React from "react";
import { makeStyles } from "@mui/styles";
import _ from "lodash"

const useStyles = makeStyles(() => ({
  customLabel: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#8391BE",
    marginLeft: "1px",
  }
}));

export default function TextArea(props) {
  const classes = useStyles();
  return (
    <div>
      <label className={classes.customLabel}>
        {props.label}
        {(_.get(props,"required", true)) && <span style={{ color: "red" }}> *</span>}
      </label>
      <textarea
        id={props.id?props.id:"w3review"}
        style={{
          width: props.width ? props.width : "100%",
          fontFamily: "'Poppins', sans-serif",
          fontWeight: props.fontWeight ? props.fontWeight : "500",
          fontSize: props.fontSize ? props.fontSize : "15px",
          border: props.border ? props.border : "1px solid #cbcaca",
          resize: props.resize ? props.resize : "none",
          padding: props.padding ? props.padding : "8px",
          color: props.color ? props.color : "#707EAE",
          margin: props.margin,
          marginTop: props.marginTop?props.marginTop:"7px",
          borderRadius: props.borderRadius ? props.borderRadius : "6px"
        }}
        name={props.name}
        rows={props.minRows}
        placeholder={props.placeholder}
        {...props.inputRef}
        maxLength={props.maxLength}  // Corrected spelling to maxLength
      />
    </div>
  );
}
